// OrderHeader.tsx
import React from "react";
import { CircleChevronLeft } from "lucide-react";

interface OrderHeaderProps {
  onClose: () => void;
}

const OrderHeader: React.FC<OrderHeaderProps> = ({ onClose }) => {
  return (
    <div className="flex items-center gap-3 mb-6">
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          <CircleChevronLeft className="w-6 h-6 bg-[#808080] text-white rounded-full mr-2" />
        </button>
      <h1 className="text-xl font-semibold text-gray-800">Prepare Order</h1>
    </div>
  );
};

export default OrderHeader;
